<template >
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top" >
            <b-navbar-brand href="#">
                <b-icon   icon="person-square"></b-icon>  {{ $route.query.desc }} </b-navbar-brand>
                 <b-navbar-nav class="ml-auto">
                <b-nav-item @click="goback()" > 
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>

        <b-row>
            <b-col>
                <b-card header="ລາຍງານປະຈຳວັນ">
                    <b-form @submit.prevent="onPreview">
                        <b-form-group  :label="$t('users.branch_id')" label-cols="4"  >
                     
                     <b-form-select
                     v-model="fld.prov_id"
                     :options="provices"
                     required 
                   ></b-form-select>
                 </b-form-group>
 
                 <b-form-group  label="ແຫຼ່ງທຶນ"  label-cols="4" >
                      
                      <b-form-select
                      v-model="fld.source_type"
                      :options="source_types"
                      required
                    ></b-form-select>
                </b-form-group>

                        <b-row>
                            <b-col>
                                <b-form-group label="ແຕ່ວັນທີ:" label-cols="4">
                                    <b-form-datepicker v-model="fld.fromdate" locale="lao"></b-form-datepicker>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="ເຖິງວັນທີ:" label-cols="4">
                                    <b-form-datepicker v-model="fld.todate" locale="lao"></b-form-datepicker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- 
            <b-row>

                <b-col>
                    <b-form-group :label="$t('users.prov_id')" label-cols="4">
                        <b-form-select v-model="fld.prov_id" :options="provices" required @input="getBorders">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>



            <b-row>
                <b-col>
                    <b-form-group :label="$t('users.border_id')" label-cols="4">
                        <b-form-select v-model="fld.border_id" :options="borders" required></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row> -->

                        <b-button block type="submit" variant="outline-primary"> {{ $t('button.preview') }} </b-button>


                    </b-form>

                </b-card>
            </b-col>
             
        </b-row>

        

        






    </div>
</template>
<script>
import axios from "axios";
export default {

    data() {
        return {
            provices: [],
            dep: [],
            schools:[],
            user:[],
            source_types:[],

            fld: {
                fromdate: "",
                todate: "",
                prov_id: "",
                district_id:"",
                school_id:"",
                reportname: this.$route.query.reportname,
                branch_id:'',
                params:"",
                source_type:""

            },
             
            month: '',
            yyyy: '',
            mm: [
                { value: 1, text: "1" },
                { value: 2, text: "2" },
                { value: 3, text: "3" },
                { value: 4, text: "4" },
                { value: 5, text: "5" },
                { value: 6, text: "6" },
                { value: 7, text: "7" },
                { value: 8, text: "8" },
                { value: 9, text: "9" },
                { value: 10, text: "10" },
                { value: 11, text: "11" },
                { value: 12, text: "12" },

            ],
            quater: '',
            qq: [
                { value: 1, text: "1" },
                { value: 2, text: "2" },
                { value: 3, text: "3" },
                { value: 4, text: "4" },
            ]
        }
    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.fld.branch_id=this.user.branch_id
        this.fld.prov_id=this.user.prov_id
        this.fld.district_id=this.user.district_id
        this.fld.school_id=this.user.school_id

        if(this.user.org_type_code==1){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/province/prov_name/prov_id",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


          
        }else if(this.user.org_type_code==2){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/province/prov_name/prov_id/prov_id/"+this.user.prov_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })


                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



        }else if(this.user.org_type_code==3){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/province/prov_name/prov_id/prov_id/"+this.user.prov_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                

                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



        }

        else if(this.user.org_type_code==4){
            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/province/prov_name/prov_id/prov_id/"+this.user.prov_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });


            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                

                axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/school_id/" + this.fld.school_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })



        }


            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/source_types/source_type_desc/source_type",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_types = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });
        /*
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/provinces/province_lao/prov_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });
            */

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },

        getBorders() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/borders/border_name_lao/border_id/prov_id/" + this.fld.prov_id
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.borders = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onPreview() {
            this.fld.caption="ແຕ່ວັນທີ່: " + this.fld.fromdate + " ຫາ " + this.fld.todate
            let data = JSON.stringify(this.fld);
            this.$router.push('/view_dna_api/rpt_dialys_allp/slfis_daily_report_p.mrt?data=' + data)
        },
        fnEnofmonth(){
        
           // var date = new Date();
           // var firstDay = new Date(this.yyyy, parseInt(this.month)-1, 1);
            var lastDay = new Date(this.yyyy , parseInt(this.month) , 0);
            var firstDay1 =    this.yyyy + '-' +(lastDay.getMonth() +1) +'-01' ;
            var lastDayWithSlashes =   this.yyyy + '-'+(lastDay.getMonth() +1) +'-'+(lastDay.getDate()) ;
           
           // $('#from_date').val(firstDay1);
           // $('#to_date').val(lastDayWithSlashes);
           // $('#yy').val($('#yyyy').val());
            this.fld.fromdate=firstDay1
            this.fld.todate=lastDayWithSlashes
           // var m=parseInt(this.month);
          // console.log(firstDay1)
        

        },
         fnEnofmonth_quarter(){
        
           // var date = new Date();
           // var firstDay = new Date(this.yyyy, parseInt(this.month)-1, 1);
           // let mmm=this.quater

            var lastDay = new Date(this.yyyy , parseInt(this.quater) , 0);
            var firstDay1 =    this.yyyy + '-' +(lastDay.getMonth() +1) +'-01' ;
             var lastDay2 = new Date(this.yyyy , parseInt(this.quater*3) , 0);
            var lastDayWithSlashes =   this.yyyy + '-'+(lastDay2.getMonth() +1) +'-'+(lastDay2.getDate()) ;
           
           // $('#from_date').val(firstDay1);
           // $('#to_date').val(lastDayWithSlashes);
           // $('#yy').val($('#yyyy').val());
            this.fld.fromdate=firstDay1
            this.fld.todate=lastDayWithSlashes
           // var m=parseInt(this.month);
          // console.log(firstDay1)
        

        },
        getDep() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getscholls(){
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    },
}
</script>
<style  scoped >
.content {
    margin-top: 80px;
}

.notolao {
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
}
</style>